<template>
<div>
    <div class="details-modal--tabs">
        <div
            :class="{selected: selectedTab === 'responses' }"
            class="details-modal--tab"
            @click="selectTab('responses')"
        >
            {{ $t('model.nlu-model.prebuilt-models.prebuilt-model-card.responses') }}
        </div>
        <div
            v-if="isCurrentKMWithEntityExtractions"
            :class="{selected: selectedTab === 'entities' }"
            class="details-modal--tab details-modal--tab-right"
            @click="selectTab('entities')"
        >
            {{ $t('model.nlu-model.prebuilt-models.prebuilt-model-card.entities') }}
        </div>
    </div>
    <div class="details-modal--content">
        <div
            class="table"
            :key="tableItems.length"
        >
            <div class="table__header">
                <CustomGroupCheckbox
                    class="checkbox"
                    :groupState="groupState"
                    @toggle-checkbox-group="toggleCheckboxGroup"
                />
                <span>{{tableHeaderLabel}}</span>
            </div>
            <div class="table__body">
                <TableItem
                    v-for="(item, index) in tableItems"
                    :key="`${item}:${index}`"
                    :item="item"
                    :selectedTab="selectedTab"
                    :selectedItems="localSelectedItems"
                    @toggle="onToggle"
                />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomGroupCheckbox from '@/components/common/custom_group_checkbox'
import TableItem from './table-item'

export default {
  components: {
    CustomGroupCheckbox,
    TableItem
  },

  props: {
    responses: Array,
    entities: Array,
    selectedItems: Object
  },

  computed: {
    ...mapGetters('knowledgebase', ['isCurrentKMWithEntityExtractions']),

    localSelectedItems: {
      get () {
        return this.selectedItems
      },
      set (value) {
        this.$emit('update:selected-items', value)
      }
    },

    tableItems () {
      return this.selectedTab === 'responses'
        ? this.$props.responses
        : this.$props.entities
    },

    tableHeaderLabel () {
      const path = this.selectedTab === 'responses'
        ? 'model.nlu-model.prebuilt-models.prebuilt-model-card.responses'
        : 'model.nlu-model.prebuilt-models.prebuilt-model-card.entities'

      return this.$t(path)
    },

    allIds () {
      return this.selectedTab === 'responses'
        ? this.$props.responses.map(item => item.id)
        : this.$props.entities.map(item => item.id)
    },

    groupState () {
      if (this.allIds.every(id => this.localSelectedItems[`${this.selectedTab}`].includes(id)) &&
        (this.localSelectedItems[`${this.selectedTab}`].length > 0)) {
        return 'checked'
      }
      if (this.allIds.some(id => this.localSelectedItems[`${this.selectedTab}`].includes(id))) {
        return 'some-checked'
      }

      return 'not-checked'
    },

    allResponsesIds () {
      return this.responses.map(obj => obj.id)
    },

    allEntitiesIds () {
      return this.entities.map(obj => obj.id)
    }
  },

  data () {
    return {
      selectedTab: 'responses'
    }
  },

  methods: {
    selectTab (selectedTab) {
      this.selectedTab = selectedTab
    },

    toggleCheckboxGroup () {
      if (_.every(this.allIds, id => _.includes(this.localSelectedItems[`${this.selectedTab}`], id))) {
        this.localSelectedItems[`${this.selectedTab}`] = _.filter(this.localSelectedItems[`${this.selectedTab}`], itemId => !_.includes(this.allIds, itemId))
      } else {
        this.allIds.forEach(id => {
          if (!this.localSelectedItems[`${this.selectedTab}`].includes(id)) {
            this.localSelectedItems[`${this.selectedTab}`].push(id)
          }
        })
      }
    },

    onToggle ({ id, target }) {
      this.localSelectedItems[`${target}`] = this.localSelectedItems[`${target}`].includes(id)
        ? _.filter(this.localSelectedItems[`${target}`], itemId => itemId !== id)
        : [...this.localSelectedItems[`${target}`], id]
    }
  }
}
</script>

<style lang="scss" scoped>
.details-modal--tabs {
    display: flex;
    padding: 0 16px 0;
    border-bottom: solid 1px $or-grey-medium;

    .details-modal--tab {
        padding: 16px 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: rgb(108, 116, 125);
        cursor: pointer;

        &.selected {
            border-bottom: solid 2px $or-black-blue;
            color: $or-black-blue;
        }
    }
    .details-modal--tab-right {
        margin-left: 32px;
    }
}

.details-modal--content {
    margin-top: 16px;
    // margin-bottom: 24px;

    .table {
        position: relative;

        &__overlaps {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(255, 255, 255, 0.6);
            z-index: 999;
        }
        &__header {
            display: flex;
            align-items: center;
            font-size: 14px;
            line-height: 16px;
            font-weight: bold;
            background-color: $or-grey-medium;
            border: solid 1px $or-grey-medium;
            border-top-left-radius: 4px;
            border-top-right-radius: 4px;
            height: 36px;
            padding: 10px;

            .checkbox {
                margin-right: 22px;
            }
        }
        &__body {
            display: flex;
            flex-direction: column;
            max-height: 280px;
            overflow: scroll;
            border: none;
        }
    }
}
</style>
